import WarrantyDocumentsContainer from './warranty-documents-container';

export default WarrantyDocumentsContainer;
